import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 39.93 35.51"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "4",
      d: "M19.96 13.382v7m0 7h.018m-2.44-22.94L3.144 29.305c-.798 1.38-1.197 2.069-1.138 2.635.051.493.31.942.711 1.234.46.334 1.257.334 2.85.334h28.788c1.593 0 2.39 0 2.85-.334.401-.292.66-.74.711-1.234.06-.566-.34-1.256-1.138-2.635L22.384 4.443c-.795-1.374-1.193-2.061-1.712-2.292a1.75 1.75 0 0 0-1.422 0c-.519.23-.917.918-1.712 2.292"
    }, null, -1)
  ]))]))
}
export default { render: render }